// extracted by mini-css-extract-plugin
export default {"desktop":"rivj5fPy8z5ztvqp2Et6","mobile":"nnLzjLvOz_mnFUEucmdA","pulse":"lu0QhsYu0tUT2U5UVSaM"};